'use client'
// TODO: Xóa đi khi đã chuyển hết sang v2
import { VerifyPhone } from '@/components/auth/verify-phone'
import { toast } from '@/components/common/toast'
import { usePostLogin } from '@/hooks/react-query/auth/use-post-login'
import { useRouter } from '@/i18n/navigation'
import { showPopup } from '@/providers/popup-provider'
import { useLocale } from 'next-intl'
import { useSearchParams } from 'next/navigation'
import { useEffect } from 'react'

interface VerifyTokenData {
  isset_phone: boolean
  phone: string
  user_id: string
  email: string
  service: string
  is_login: boolean
  fullname: string
}

export const VerifyProvider = ({ children }: { children: React.ReactNode }) => {
  const searchParams = useSearchParams()
  const router = useRouter()
  const locale = useLocale()
  const postLogin = usePostLogin()

  const processAfterLoginSuccess = async () => {
    try {
      // Chỉ invalidate/selective + điều hướng nhẹ (không refresh)
      postLogin()

      toast.message({
        title: 'Đăng nhập thành công',
        message: ' Mời bạn trải nghiệm mua sắm thời trang tại Coolmate.',
      })

      // Remove verify_token from URL
      const newSearchParams = new URLSearchParams(searchParams)
      newSearchParams.delete('verify_token')

      const newUrl = newSearchParams.toString()
        ? `${window.location.pathname}?${newSearchParams.toString()}`
        : window.location.pathname

      router.replace(newUrl, { locale })
    } catch (error) {
      console.error('Error in processAfterLoginSuccess:', error)
    }
  }

  useEffect(() => {
    const verifyToken = searchParams.get('verify_token')

    if (!verifyToken) return

    try {
      // Decode the base64 encoded token
      const decryptedData: VerifyTokenData = JSON.parse(atob(verifyToken))

      // Check if phone is not set, then show verify phone popup
      if (!decryptedData.isset_phone) {
        showPopup(
          <VerifyPhone
            user={{
              fullname: decryptedData.fullname || '',
              email: decryptedData.email || '',
              id: decryptedData.user_id || '',
            }}
            isConfirm={decryptedData.is_login}
            onSuccess={processAfterLoginSuccess}
          />
        )
      } else {
        // If phone is already verified, just process login success
        processAfterLoginSuccess()
      }
    } catch (error) {
      console.error('Error decoding verify_token:', error)
      toast.message({
        title: 'Không thể xác thực',
        message: 'Token xác thực không hợp lệ.',
      })
    }
    // Chỉ re-run khi verify_token thay đổi để tránh loop
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParams.get('verify_token')])

  return <>{children}</>
}
